import { TreeBuilder } from "./tree-builder";
import { TreeNode } from "./lib/tree-node";
import { Node } from "../graph/lib/node";

//Deprecated
export abstract class TreeNoRepBuilder extends TreeBuilder {
    constructor(depth: number, set: any[], canvas: HTMLCanvasElement) {
        super(depth, set, canvas);
        this.update();
    }
    

    keyboardEvent(e: KeyboardEvent){

    }



    addTreeNode(row: number, col: number, parent: TreeNode, maxWidth?:number): TreeNode {

        let newContent: any[] = [];

        if (parent != null) {
            let parentContent = parent.getContent();

            parentContent.forEach(content => {
                newContent.push(content);
            })

            let pureContent: string[] = [];
            this.set.forEach(content => {
                if (!parentContent.includes(content)) {
                    pureContent.push(content);
                }
            })

            let index = parent.getNeighbors().length;
            if (index < pureContent.length)
                newContent.push((pureContent)[index]);
        }
        let newNode: TreeNode = this.createNewNode(row, col, null, parent, newContent, this.set, this.depth, maxWidth);
        this.nodes.push(newNode);
        this.addEdge(parent, newNode);
        return newNode;
    }

    /**
     * 
     * @param row 
     * @param col 
     * @param id 
     * @param parent 
     * @param content 
     * @param alphabet 
     * @param depth 
     * @returns new Node of a desired subtype of TreeNode
     */
    protected abstract createNewNode(row:number, col:number, id:number, 
        parent:TreeNode, content: any[], alphabet: any[], depth: number, maxWidth?:number): TreeNode;


    protected getNumberChild(curDepth: number): number {
        if(curDepth == 1){
            return this.set.length;
        }
        return (this.set.length - (curDepth-1)) * this.getNumberChild(curDepth-1);
    }

    protected childrenSize(curDepth: number): number {
        if(curDepth == 1 || curDepth == 0){
            return this.set.length;
        }
        return this.childrenSize(curDepth-1)-1;
    }

}